import React, { Component } from "react"
import { Link } from "gatsby"
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModal from "../components/utilities/SimpleModal"

import "./casestudyomnissa.scss"

import imgQuote from "../images/quotation_mark.webp"

export default ({ pageContext }) => (
  <Layout>
    <SEO
      title={pageContext.yoast.title}
      description={pageContext.yoast.metadesc}
      ogimg={pageContext.yoast.opengraph_image}
      link={pageContext.link}
    />
    <div className="case-study-om-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div
            className="header-container"
            style={{
              backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
            }}
          >
            <img src={imgQuote} alt="" />
            <h2>{pageContext.acf.header_text}</h2>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                  .fluid.src
              }
              className="client-logo"
              width={pageContext.acf.client_logo.media_details.width / 1.5}
              height={pageContext.acf.client_logo.media_details.height / 1.5}
              alt={pageContext.yoast.opengraph_title}
            />
          </div>
          <div className="col-md-4">
            <a
              href="https://www.meritmile.com/uploads/2026/05/omnissa-case-study.pdf"
              className="btn downloadBtn"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ marginTop: "4em" }}
            >
              Download the PDF here
            </a>
          </div>
          <div className="col-12">
            <div className="bar"></div>
          </div>
          <div className="col-12">
            <div
              className="first-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.first_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/05/omnissa-intro.webp"
              className="results-image img-fluid"
              alt="Omnissa Intro Room"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h3>Challenge</h3>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              Omnissa needed a reliable way to accelerate pipeline growth within
              a defined set of high-value enterprise accounts, focusing not on
              volume and top-of-funnel MQLs, but on sales-ready BANT leads, reaching
              in-market decision-makers with strong intent signals.
            </p>
          </div>
          <div className="col-12 col-md-6">
            <p>
              The challenge was clear: connect with senior decision-makers
              across a very specific set of targeted accounts, generate qualified
              opportunities, and directly align marketing performance with sales
              outcomes. At the same time, Omnissa needed a model that could
              scale, expanding across regions without sacrificing efficiency or
              impact.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className="third-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.third_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <p>
              The program was piloted in the Southeast United States region,
              where early success validated both the strategy and execution.
              Building on that momentum, the campaign was expanded into the
              Northeast region—applying learnings, refining targeting, and
              scaling performance across a broader set of high-value accounts.
            </p>
            <p>
              At the core of the program was a double-touch engagement model.
              Prospects first engaged with Omnissa content—such as eBooks and
              IDC analyst reports—through targeted campaigns.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/05/omnissa-solutions.webp"
              className="results-image img-fluid"
              alt="Omnissa Case Study Solution"
              width="750px"
              style={{ marginBottom: "2em" }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <p>
              From there, Merit Mile's BDR partner team conducted <strong>tele-qualification
              outreach</strong>, verifying contact details and asking a series of custom
              qualification questions aligned to Omnissa's priorities. Only
              prospects who demonstrated clear interest, met qualification
              criteria, and explicitly opted into a follow-up were delivered as
              leads—ensuring every engagement was validated, intentional, and
              sales-ready.
            </p>
            <p>
              Beyond lead generation, Merit Mile delivered significant value
              through <strong>ongoing reporting and sales enablement support</strong>. Weekly
              campaign reports provided full visibility into performance and
              engagement, including detailed lead profiles, qualification
              responses, and <strong>call notes capturing real conversations with
              prospects</strong>. Each lead was enriched with context such as <strong>LinkedIn
              profiles and engagement insights</strong>, giving Omnissa's sales team a
              clear understanding of the buyer's needs, pain points, and level
              of interest.
            </p>
            <p>
              Merit Mile also provided <strong>best practices for follow-up and nurture</strong>,
              equipping sellers with recommended cadences, messaging strategies,
              and multi-channel engagement approaches to maximize conversion and
              accelerate pipeline progression.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Results</h3>
            <p>
              Across two consecutive campaigns, the program delivered strong,
              repeatable performance—driving both engagement and measurable
              pipeline impact.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/05/omnissa-results.webp"
              className="results-image img-fluid"
              alt="Teladoc Health Microsoft Case Study Screenshot"
              width="728px"
              style={{ marginBottom: "2em" }}
            />
          </div>
          <div className="col-12 col-md-6">
            <p>
              Merit Mile delivered 239 <strong>double-touch leads and drove engagement
              across 130 target-account interactions</strong>, all within efficient
              in-market campaign timelines averaging 2 months.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              By the conclusion, the campaigns generated <strong>$3M in pipeline and
              influenced an additional $2.8M</strong>, achieving <strong>10X+ ROI under
              conservative win-rate assumptions</strong>. As opportunities continued to
              progress through the sales cycle, these numbers have continued to
              grow.
            </p>
          </div>
          <div className="col-12 col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/05/omnissa-results-2.webp"
              className="results-image img-fluid"
              alt="Teladoc Health Microsoft Case Study Screenshot"
              width="728px"
              style={{ marginBottom: "2em" }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              Beyond volume, engagement quality improved significantly over
              time. The second campaign saw a substantial increase in
              senior-level reach, with <strong>45% of total leads coming from C-level
              executives</strong>, up from 15% in the initial campaign—demonstrating the
              program's ability to connect with high-value decision-makers who
              are typically difficult to engage.
            </p>
            <p>
              Just as importantly, the depth of insight provided with each lead
              enabled more informed and effective follow-up. With detailed call
              notes, qualification data, and buyer context readily available,
              Omnissa's sales team was able to engage prospects with greater
              relevance, helping convert initial interest into meaningful
              pipeline opportunities.
            </p>
          </div>
          <div className="col-12 col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/05/omnissa-leadership-account-level-penetration.webp"
              className="intro-image"
              width=""
              alt="Omnissa Leadership Account Level Penetraton"
              style={{ marginBottom: "2em", maxWidth: "90%" }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Outcome</h3>
            <p>
              The success of these campaigns established a strong foundation for
              continued growth. What began as a targeted ABM initiative in a
              single region evolved into a scalable, repeatable model—expanding
              geographically and continuing to generate new opportunities.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              Merit Mile continues to partner with Omnissa to build on this
              momentum, applying proven strategies to new European regions,
              introducing additional channels, and further strengthening
              alignment between marketing and sales.
            </p>
          </div>
          <div className="col-12 col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/05/logo-lockup-omnissa-merit-mile.webp"
              className="intro-image"
              width=""
              alt="Omnissa and Merit Mile"
              style={{ marginBottom: "2em", maxWidth: "90%" }}
            />
          </div>
        </div>
      </div>
      <div className="fullWidthGrayCTA">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                Contact <a href="mailto:ABM@MeritMile.com?subject=Omnissa%20Case%20Study%20Inquiry">
                  <b style={{ color: "black", textDecoration: "underline" }}>ABM@MeritMile.com</b>
                </a> or visit <a href="/abm/"><b style={{ color: "black", textDecoration: "underline" }}>www.meritmile.com/abm/</b></a> to learn more about proven, predictable, and measurable ABM. 
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper">
        <img
          src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
          alt="Merit Mile Icon Divider"
          className="img-fluid"
        />
      </div>
      <div className="about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About Merit Mile</h2>
            </div>
          </div>
          <div className="row margin-b">
            <div className="col-md-6">
              <p>
                Established in 2007 in Boca Raton, FL, Merit Mile is a marketing
                services provider focused on helping companies and corporate
                marketing departments build brands, drive sales revenue, and
                garner publicity in their respective industries. Our unique
                differentiator at Merit Mile is our ability to 100% own the
                message, the publicity, and the demand generation aspects of the
                corporate marketing function. Clients hire us and rehire us for
                our ability to refine their messaging/value proposition, develop
                top and mid-funnel leads, and get the type of editorial
                publicity that differentiates them from their competitors. From
                branding to PR to demand generation, Merit Mile is the
                high-octane fuel that invigorates corporate growth engines. To
                learn more, please email us at Hello@MeritMile.com, call us at
                1-561-362-888, or visit us at www.MeritMile.com.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp"
                alt="Merit Mile Headquarter in Boca Raton, FL"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container quote-wrapper">
        <div className="row">
          <div className="col-12">
            <p>
              For more insights and to connect
              <br />
              with Merit Mile{" "}
              <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry">
                <b style={{ color: "black" }}>email us here</b>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
